import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/calcom/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
